import React, { useState, useEffect } from 'react';
import Adminsidebar from '../components/Adminsidebar';
import Adminheader from '../components/Adminheader';
import Uppercase from '../components/Uppercase';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { FaEdit, FaTrashAlt, FaDownload, FaEye } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
// import { useYearContext } from '../components/YearContext';

function Adminclients() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  // const { yearSelected } = useYearContext();

  const navigate = useNavigate();
  
  // Commented out employee data functionality
  // const [employeeData, setEmployeeData] = useState([]);
  // const [selectedEmployees, setSelectedEmployees] = useState('');

  // useEffect(() => {
  //   const fetchEmployeeData = async () => {
  //     try {
  //       const response = await axios.get(
  //         "https://api.litaxfilers.com/api/getemployeess"
  //       );
  //       setEmployeeData(response.data);
  //     } catch (error) {
  //       console.error('Error fetching employee data:', error);
  //     }
  //   };
  //   fetchEmployeeData();
  // }, []);

  const [clientData, setClientData] = useState([]);
  
  // Commented out lead data functionality
  // const [leadData, setLeadData] = useState([]);

  const fetchClientData = async () => {
    try {
      const response = await axios.get("https://api.litaxfilers.com/get/clientdataa");
      if (response.data.success) {
        setClientData(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClientData();
  }, []);

  // Commented out leads data functionality
  // const fetchLeadsData = async () => {
  //   try {
  //     const response = await axios.get("https://api.litaxfilers.com/get/leaddataa");
  //     if (response.data.success) {
  //       setLeadData(response.data.results);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //  fetchLeadsData();
  // },[])

  const [selectedRows1, setSelectedRows1] = useState([]);
  const [checkAll, setCheckAll] = useState(false);

  const handleCheckboxChangeid = (id) => {
    const isSelected = selectedRows1.includes(id);
    const updatedSelection = isSelected
      ? selectedRows1.filter((rowId) => rowId !== id)
      : [...selectedRows1, id];

    setCheckAll(updatedSelection.length === records.length);
    setSelectedRows1(updatedSelection);
  };

  const handleCheckAll = () => {
    if (checkAll) {
      setSelectedRows1([]);
    } else {
      setSelectedRows1(records.map((record) => record.id));
    }
    setCheckAll(!checkAll);
  };

  // Commented out employee change functionality
  // const handleEmployeeChange = (employee) => {
  //   setSelectedEmployees(employee.id);
  // };

  // Commented out OK click functionality
  // const handleOkClick = () => {
  //   if (selectedRows1.length === 0 || selectedEmployees === '') {
  //     toast.warn('Please select at least one client and one employee.');
  //     return;
  //   }
  //   handleAssignEmployee();
  // };

  // Commented out assign employee functionality
  // const handleAssignEmployee = async () => {
  //   try {
  //     const response = await axios.put("https://api.litaxfilers.com/updateclients", {
  //         selectedRows1,
  //         selectedEmployees,
  //       }
  //     );
  //     if (response.data.success) {
  //       toast.success('The values updated successfully');
  //       window.location.reload();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // Commented out lead info functionality
  // const getLeadInfo = (email) => {
  //   const lead = leadData.find((lead) => lead.email === email);
  //   console.log(lead);
  //   if (lead) {
  //     return {
  //       inLeads: 'YES',
  //       assignedAt: lead.assigned_date,
  //       assignedTo: lead.assigned_to
  //     };
  //   }
  //   return {
  //     inLeads: 'NO',
  //     assignedAt: 'Unassigned date',
  //   };
  // };

  const handleonExport = () => {
    // Create a new worksheet from the client data
    const worksheetData = clientData.map((doc) => {
      // Commented out lead info functionality
      // const leadInfo = getLeadInfo(doc.email);
      return {
        'Client ID': doc.client_id,
        'Client Name': doc.client_name,
        Email: doc.email,
        Contact: doc.phoneNumber,
        'Alternate Contact': doc.alternateContact,
        // Commented out lead-related fields
        // 'In Leads': leadInfo.inLeads,
        // 'Assigned To': doc.assigned_to,
        // 'Assigned At': leadInfo.assignedAt || doc.assigned_date,
        'Registered At': doc.registeredAt,
        Status: doc.status,
        Comments: doc.comments,
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Client Data');
    XLSX.writeFile(workbook, 'ClientData.xlsx');
  };

  //filters
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    clientName: '',
    status: '',
  });

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const filterDocuments = clientData.filter((doc) => {
    const { dateFrom, dateTo, clientName, status } = filters;
    const lowerCaseStatus = status.toLowerCase();
    const documentDate = doc.registered_at
      ? doc.registered_at.substring(0, 10)
      : '';
    const fromDate = dateFrom ? dateFrom : '';
    const toDate = dateTo ? dateTo : new Date().toISOString().substring(0, 10);

    // const nextYear = (parseInt(yearSelected) + 1).toString();

    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;

    return (
      // documentDate >= startDate &&
      // documentDate <= endDate &&
      (dateFrom === '' || documentDate >= fromDate) &&
      (dateTo === '' || documentDate <= toDate) &&
      (clientName === '' ||
        doc.client_name.toLowerCase().includes(clientName.toLowerCase())) &&
      (status === '' || doc.status.toLowerCase() === lowerCaseStatus)
    );
  });



  const reversedDocuments = filterDocuments.slice().reverse();

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reversedDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };


  const changeCpage = (id) => {
    setCurrentPage(id);
  };

  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [formdata, setFormdata] = useState({
    status: '',
    comments: '',
  });

  const handleChange = (e) => {
    setFormdata((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        `https://api.litaxfilers.com/editclient/${editID}`,
        formdata
      );

      if (response && response.data && response.data.success) {
        toast.success('Client updated successfully');
        
          window.location.reload();
       

        setFormdata({
          status: '',
          comments: '',
        });
      } else {
        toast.error('Failed to update client');
      }
    } catch (error) {
      console.error('Error updating client:', error);
      toast.error('An error occurred while updating the client.');
    }
  };

  const [editID, setEditID] = useState('');
  const handleEdit = (id, status, comments) => {
    setEditID(id);
    setFormdata({
      status: status,
      comments: comments,
    });
  };

  const handleDelete = (client_id) => {
    if(selectedRows1.length > 1){
      toast.error("Multiple records can not be deleted")
    }
    else{
    Swal.fire({
      title: 'Are you sure?',
      position: 'top',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        popup: 'swal-custom-height', // Apply custom class here
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://api.litaxfilers.com/delete/client/${client_id}`)
          .then(() => {
            toast.success('client deleted Successfully');
            window.location.reload();
          })
          .catch((err) => {
            toast.error('Error deleting client');
            console.log(err);
          });
      }
    });
  }
  };

  const handleView = (email) => {
    navigate('/viewclientdocs', { state: { clientEmail: email } });
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <div
              className="row mt-2"
              style={{
                fontSize: '12px', // Smaller text size
                marginBottom: '5px',
              }}
            >
              <div
                className="col-lg-12 d-flex flex-wrap align-items-center gap-2"
                style={{ rowGap: '10px' }} // Adjust spacing between elements
              >
                {/* Commented out Assign To Dropdown functionality */}
                {/* <div className="d-flex align-items-center gap-2">
                  <div className="dropdown">
                    <button
                      className="btn btn-primary btn-sm dropdown-toggle"
                      data-bs-toggle="dropdown"
                      disabled={selectedRows1.length === 0}
                    >
                      Assign To ({selectedRows1.length})
                    </button>
                    <ul
                      className="dropdown-menu"
                      style={{
                        maxHeight: '150px', // Reduce height
                        overflowY: 'auto',
                        fontSize: '12px', // Smaller font size
                        padding: '2px', // Minimize padding for dropdown items
                      }}
                    >
                      <div>
                        {employeeData.map((employee, index) => (
                          <li
                            key={index}
                            className="dropdown-item"
                            style={{ padding: '4px 8px' }}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <input
                                type="radio"
                                value={employee.username}
                                checked={selectedEmployees === employee.id}
                                onChange={() => handleEmployeeChange(employee)}
                              />
                              <span>{employee.username}</span>
                            </div>
                          </li>
                        ))}
                      </div>
                      <div className="btndiv">
                        <button
                          onClick={handleOkClick}
                          className="btn btn-primary btn-sm assignbtn"
                          style={{
                            padding: '4px 8px',
                            fontSize: '12px',
                            marginLeft: '50px',
                          }}
                        >
                          Assign
                        </button>
                      </div>
                    </ul>
                  </div>
                </div> */}

                <button
                  className="btn btn-secondary btn-sm"
                  onClick={handleonExport}
                  style={{ lineHeight: '1' }}
                >
                  <FaDownload />
                </button>

                {/* Date From */}
                <div>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="dateFrom"
                    value={filters.dateFrom}
                    onChange={handleFilterChange}
                    style={{ minWidth: '150px' }}
                  />
                </div>

                {/* Date To */}
                <div>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="dateTo"
                    value={filters.dateTo}
                    onChange={handleFilterChange}
                    style={{ minWidth: '150px' }}
                  />
                </div>

                {/* Client Name */}
                <div>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Client Name"
                    name="clientName"
                    value={filters.clientName}
                    onChange={handleFilterChange}
                    style={{
                      minWidth: '150px',
                      height: '30px',
                      padding: '5px',
                    }}
                  />
                </div>

                {/* Status Dropdown */}
                <div>
                  <select
                    className="form-select form-select-sm"
                    name="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                    style={{ minWidth: '150px' }}
                  >
                    <option
                      value=""
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      All Statuses
                    </option>
                    <option
                      value="Registered"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Registered
                    </option>
                    <option
                      value="Callback"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Callback
                    </option>
                    <option
                      value="Voicemail"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Voicemail
                    </option>
                    <option
                      value="Wrongnumber"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Wrong Number
                    </option>
                    <option
                      value="Intrested"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Interested
                    </option>
                    <option
                      value="Not Intrested"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Not Interested
                    </option>
                    <option
                      value="Documentpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Document Pending
                    </option>
                    <option
                      value="Duplicate"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Duplicate
                    </option>
                    <option
                      value="Alreadyfiledtaxes"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Already Filed Taxes
                    </option>
                    <option
                      value="Documentsuploaded"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Documents Uploaded
                    </option>
                    <option
                      value="Preparationpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Preparation Pending
                    </option>
                    <option
                      value="Additionaldocumentpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Additional Document Pending
                    </option>
                    <option
                      value="Reviewpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Review Pending
                    </option>
                    <option
                      value="Reviewcompleted"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Review Completed
                    </option>
                    <option
                      value="Clientreview"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Client Review
                    </option>
                    <option
                      value="Paymentpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Payment Pending
                    </option>
                    <option
                      value="Paid"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Paid
                    </option>
                    <option
                      value="Partialpayment"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Partial Payment
                    </option>
                    <option
                      value="Finaldocumentsent"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Final Document Sent
                    </option>
                    <option
                      value="Efilingpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      E Filing Pending
                    </option>
                    <option
                      value="Itindocumentssenttoclient"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      ITIN Documents Sent to Client
                    </option>
                    <option
                      value="Itincertificationpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      ITIN Certification Pending
                    </option>
                    <option
                      value="Statefilingpending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      State Filing Pending
                    </option>
                    <option
                      value="Filingcopypending"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Filing Copy Pending
                    </option>
                    <option
                      value="Filingcopyuploaded"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Filing Copy Uploaded
                    </option>
                    <option
                      value="Finaldrafttobeuploaded"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Final Draft to be Uploaded
                    </option>
                    <option
                      value="Signature8879senttoclient"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Signature 8879 Sent to Client
                    </option>
                    <option
                      value="Signature8879signedcopyreceived"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Signature 8879 Signed copy Received
                    </option>
                    <option
                      value="Signature8879yettoreceive"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Signature 8879 Yet to Receive
                    </option>
                    <option
                      value="Complete"
                      style={{ fontSize: '12px', height: '30px' }}
                    >
                      Completed
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div
              className="table-container"
              style={{
                height: 'calc(89vh - 150px)', // Adjust the 150px based on your header/pagination height
                border: '1px solid #ccc',
              }}
            >
              <div className="table-responsive tablediv">
                <table
                  className="table table-hover table-bordered"
                  style={{
                    fontSize: '12px', // Smaller font size
                    lineHeight: '1.2', // Reduce line height for compact view
                  }}
                >
                  <thead className="table-primary">
                    <tr>
                      {/* <th style={{ padding: '5px' }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={checkAll}
                          onChange={handleCheckAll}
                        />
                        Check All
                      </th> */}
                      <th style={{ padding: '5px' }}>S.No</th>
                      <th style={{ padding: '5px' }}>Client ID</th>
                      <th style={{ padding: '5px' }}>Client Name</th>
                      <th style={{ padding: '5px' }}>Email</th>
                      <th style={{ padding: '5px' }}>Contact</th>
                      {/* <th style={{ padding: '5px' }}>Alternate Contact</th> */}
                      {/* Commented out lead-related columns */}
                      {/* <th style={{ padding: '5px' }}>In Leads?</th>
                      <th style={{ padding: '5px' }}>Assigned To</th>
                      <th style={{ padding: '5px' }}>Assigned At</th> */}
                      <th style={{ padding: '5px' }}>Registered At</th>
                      <th style={{ padding: '5px' }}>Status</th>
                      <th style={{ padding: '5px' }}>Comments</th>
                      <th style={{ padding: '5px' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((doc, index) => {
                      // Commented out lead info functionality
                      // const leadInfo = getLeadInfo(doc.email);
                      return (
                        <tr key={doc.id}>
                          {/* <td style={{ padding: '5px' }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedRows1.includes(doc.id)}
                              onChange={() => handleCheckboxChangeid(doc.id)}
                            />
                          </td> */}
                          <td style={{ padding: '5px' }}>
                            {filterDocuments.length -
                              ((currentPage - 1) * recordsPerPage + index)}
                          </td>
                          <td style={{ padding: '5px' }}>{doc.client_id}</td>
                          <td style={{ padding: '5px' }}>{doc.client_name}</td>
                          <td style={{ padding: '5px' }}>{doc.email}</td>
                          <td style={{ padding: '5px' }}>{doc.contact}</td>
                          {/* <td style={{ padding: '5px' }}>
                           {doc.alternateContact} 
                          </td> */}
                          {/* Commented out lead-related data */}
                          {/* <td style={{ padding: '5px' }}>{leadInfo.inLeads}</td>
                          <td style={{ padding: '5px' }}> {doc.assigned_to
                              ? doc.assigned_to
                              : leadInfo.assignedTo}</td>
                          <td style={{ padding: '5px' }}>
                            {doc.assigned_date
                              ? doc.assigned_date.substring(0, 10)
                              : leadInfo.assignedAt.substring(0, 10)}
                          </td> */}
                          <td style={{ padding: '5px' }}>
                            {doc.registered_at.substring(0, 10)}
                          </td>
                          <td style={{ padding: '5px' }}>{doc.status}</td>
                          <td style={{ padding: '5px' }}>{doc.comments}</td>
                          <td
                            style={{ padding: '5px' }}
                            className="d-flex gap-1"
                          >
                            <button
                              className="btn btn-info btn-sm"
                              onClick={() => handleView(doc.email)}
                            >
                              <FaEye />
                            </button>
                            <button
                              className="btn btn-warning btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                            >
                              <FaEdit
                                onClick={() =>
                                  handleEdit(doc.id, doc.status, doc.comments)
                                }
                              />
                            </button>
                            <button className="btn btn-danger btn-sm">
                              <FaTrashAlt
                                onClick={() => handleDelete(doc.client_id)}
                              />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div
              class="modal fade"
              id="exampleModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Edit Client
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div class="modal-body">
                      <div className="row gap-2 align-items-center">
                        <label htmlFor="status" className="col-lg-2">
                          Status
                        </label>
                        <div className="col-lg-6">
                          <select
                            className="form-select "
                            onChange={handleChange}
                            name="status"
                            value={formdata.status}
                          >
                            <option value="Registered">Registered</option>
                            <option value="Callback">Callback</option>
                            <option value="Voicemail">Voicemail</option>
                            <option value="Wrongnumber">Wrong Number</option>
                            <option value="Intrested">Intrested</option>
                            <option value="Not Intrested">Not Intrested</option>
                            <option value="Documentpending">
                              Document Pending
                            </option>
                            <option value="Duplicate">Duplicate</option>
                            <option value="Alreadyfiledtaxes">
                              Already Filed Taxes
                            </option>
                            <option value="Documentsuploaded">
                              Documents Uploaded{' '}
                            </option>
                            <option value="Preparationpending">
                              Preparation Pending
                            </option>
                            <option value="Additionaldocumentpending">
                              Additional Document Pending
                            </option>
                            <option value="Reviewpending">
                              Review Pending
                            </option>
                            <option value="Reviewcompleted">
                              Review Completed
                            </option>
                            <option value="Clientreview">Client Review</option>
                            <option value="Paymentpending">
                              Payment Pending
                            </option>
                            <option value="Paid">Paid</option>
                            <option value="Partialpayment">
                              Partial Payment
                            </option>
                            <option value="Finaldocumentsent">
                              Final Document Sent
                            </option>
                            <option value="Efilingpending">
                              E filing Pending
                            </option>
                            <option value="Itndocumentssenttoclient">
                              ITIN Documents Sent to Client
                            </option>
                            <option value="Itncertificationpending">
                              ITIN Certification Pending{' '}
                            </option>
                            <option value="Statefilingpending">
                              State filing Pending{' '}
                            </option>
                            <option value="Filingcopypending">
                              Filing Copy Pending{' '}
                            </option>
                            <option value="Filingcopyuploaded">
                              Filing Copy Uploaded
                            </option>
                            <option value="Finaldrafttobeuploaded">
                              Final Draft to be Uploaded
                            </option>
                            <option value="Signature8879senttoclient">
                              Signature 8879_Sent to Client
                            </option>
                            <option value="Signature8879signedcopyreceived">
                              Signature 8879_Signed copy Received
                            </option>
                            <option value="Signature8879yettoreceive">
                              Signature 8879_Yet to Receive
                            </option>
                            <option value="Complete">Completed</option>
                          </select>
                        </div>
                      </div>
                      <div className="row gap-2 align-items-center mt-2">
                        <label htmlFor="comments" className="col-lg-2">
                          Comments
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className="form-control"
                            name="comments"
                            value={formdata.comments}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <nav className="mt-2">
              <ul
                className="pagination"
                style={{
                  fontSize: '10px', // Reduce font size
                  padding: '0', // Remove unnecessary padding
                }}
              >
                <li className="page-item">
                  <a
                    href="#"
                    className="page-link"
                    onClick={prePage}
                    style={{
                      padding: '2px 5px', // Adjust padding for smaller height
                      height: 'auto', // Allow height to adjust with padding
                      fontSize: '12px',
                    }}
                  >
                    Prev
                  </a>
                </li>
                {numbers.map((n, i) => {
                  return (
                    <li
                      className={`page-item ${
                        currentPage === n ? 'active' : ''
                      }`}
                      key={i}
                    >
                      <a
                        href="#"
                        className="page-link"
                        onClick={() => changeCpage(n)}
                        style={{
                          padding: '2px 5px', // Reduce padding
                          height: 'auto', // Consistent height
                          fontSize: '12px',
                        }}
                      >
                        {n}
                      </a>
                    </li>
                  );
                })}
                <li className="page-item">
                  <a
                    href="#"
                    className="page-link"
                    onClick={nextPage}
                    style={{
                      padding: '2px 5px', // Same padding as above
                      height: 'auto', // Adjust height
                      fontSize: '12px',
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Adminclients;